import { render, staticRenderFns } from "./afterVerifyError.vue?vue&type=template&id=1162e0e1"
import script from "./afterVerifyError.vue?vue&type=script&lang=js"
export * from "./afterVerifyError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports